import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { ITriggerResetPasswordResponse } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

const MUT_SEND_PASSWORD_RESET_EMAIL = 'send-password-reset-email';

interface ISendPasswordResetEmailOptions {
  onErrorCallback: (err: IApiError) => void;
  onSuccessCallback: (data: ITriggerResetPasswordResponse) => void;
}

/**
 * Custom hook to send a password reset email with reset link.
 */
export const useSendPasswordResetEmailMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: ISendPasswordResetEmailOptions) => {
  const { mutate, data, isPending, error } = useMutation({
    mutationKey: [MUT_SEND_PASSWORD_RESET_EMAIL],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.triggerPasswordResetEmail,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      onErrorCallback(err);
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'useSendPasswordResetEmailMutation: Error',
        message: err.message,
      });
      return err;
    },
  });

  return {
    data,
    error,
    isPending,
    sendPasswordResetEmail: mutate,
  };
};
